import { render, staticRenderFns } from "./TwoFactorPhoneCaptureV2.vue?vue&type=template&id=2ff29976"
import script from "./TwoFactorPhoneCaptureV2.vue?vue&type=script&lang=ts"
export * from "./TwoFactorPhoneCaptureV2.vue?vue&type=script&lang=ts"
import style0 from "./TwoFactorPhoneCaptureV2.vue?vue&type=style&index=0&id=2ff29976&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports